







































































































































































import Vue from "vue";
import { settingName, UserPatch, Language, Portal, PortalMini, OutOfOffice, Controllers, UserType } from "@infoland/iprova-api";
import storeHelper from "../../../store/store-helper";
import * as Enums from "../../../enums";
import Utils from "@/utils";
import ZenyaDialog from "@/components/dialogs/ZenyaDialog.vue";
import OutOfOfficeContent from "./OutOfOfficeContent.vue";
import ChangePasswordContent from "./ChangePasswordContent.vue";
import { Constants } from "@/constants";
import QrcodeVue from "qrcode.vue";
import store from "@/store";
import { SnackBarTimeout } from "@/enums";
import { TimeZone } from "@/store/modules/timeZones/timeZones";

export default Vue.extend({
    name: "GeneralSettings",
    components: { ZenyaDialog, OutOfOfficeContent, ChangePasswordContent, QrcodeVue },
    props: {},
    data: () => {
        return {
            startPortal: null as PortalMini,
            languageCode: null as string,
            languages: null as Language[],
            showOutOfOffice: false,
            showChangePassword: false,
            changePasswordAllowed: false,
            loggedOnUsertype: null as UserType,
            outOfOffice: null as OutOfOffice,
            startDate: null,
            endDate: null,
            portals: null as Portal[],
            dateFormat: null as string,
            showLanguages: false,
            timeZone: null as TimeZone,
            timeZones: null as TimeZone[],
            timeZoneSettingEnabled: false
        };
    },
    computed: {
        formattedStartDate(): string {
            return this.$user?.out_of_office?.from
                ? Utils.formatDate(new Date(this.$user?.out_of_office.from.toDate()), this.$user?.date_format)
                : null;
        },
        formattedEndDate(): string {
            return this.$user?.out_of_office?.to ? Utils.formatDate(new Date(this.$user?.out_of_office.to.toDate()), this.$user?.date_format) : null;
        },
        dateFormats(): Object[] {
            const formats = Object.values(Enums.DateFormats);
            const results: Object[] = [];
            formats.forEach(value => {
                //the replacement is needed becase format dd.MM results in wrong translation key
                const translationKey = "general.dateFormats." + value.split(".").join("=");
                const element = {
                    text: this.$t(translationKey),
                    value: value
                };
                results.push(element);
            });
            return results;
        },
        isOutOfOffice(): boolean {
            if (this.$user?.out_of_office) {
                return true;
            }
            return false;
        },
        outOfOfficeOkLabel(): string {
            if (this.$user?.out_of_office) {
                return this.$t("settings.turnOff").toString();
            } else {
                return this.$t("settings.turnOn").toString();
            }
        },
        outOfOfficeText(): string {
            let message: string;
            if (this.$user?.out_of_office?.from) {
                message = this.$t("settings.messages.outOfOfficeEnabled").toString();
                if (
                    new Date() > new Date(storeHelper.userStore.loggedOnUser.out_of_office.from.toDate()) &&
                    storeHelper.userStore.loggedOnUser.out_of_office.to
                ) {
                    message += this.$t("settings.messages.outOfOfficeEnabledTill", { endDate: this.formattedEndDate }).toString();
                } else if (new Date() < new Date(storeHelper.userStore.loggedOnUser.out_of_office.from.toDate())) {
                    message += this.$t("settings.messages.outOfOfficeEnabledFrom", { startDate: this.formattedStartDate }).toString();
                    if (storeHelper.userStore.loggedOnUser.out_of_office.to) {
                        message += this.$t("settings.messages.outOfOfficeEnabledRangeTo", { endDate: this.formattedEndDate }).toString();
                    }
                }
            }

            return message;
        },
        twoStepOTPAuthURL(): string {
            return this.$user?.two_step_otp_auth_url;
        }
    },
    created() {
        //Doesn't have to be awaited as Vue won’t wait for it to finish. https://forum.vuejs.org/t/cant-get-created-hook-to-work-when-its-async/28604/6
        this.initAsync();
    },
    methods: {
        async initAsync(): Promise<void> {
            this.portals = storeHelper.portalStore.portals;
            this.startPortal = this.$user?.start_portal;
            this.outOfOffice = this.$user?.out_of_office;
            await this.getLanguagesAsync();
            this.changePasswordAllowed = await storeHelper.settingsStore.getSettingAsync<boolean>(settingName.users_can_change_and_request_password);
            this.loggedOnUsertype = this.$user?.user_type;
            this.showLanguages = this.languages.length > 1;
            this.languageCode = this.languages.filter(lang => lang.default == true)[0].code;
            this.dateFormat = this.$user?.date_format;
            if (this.outOfOffice) {
                if (this.outOfOffice.from) {
                    this.startDate = this.outOfOffice.from.toDate();
                }

                if (this.outOfOffice.to) {
                    this.endDate = this.outOfOffice.to.toDate();
                }
            }
            Controllers.GenericController.getAsync<boolean>("/settings/user_time_zone_enabled").then(x => {
                this.timeZoneSettingEnabled = x;
                if (x) this.loadTimeZones();
            });
        },
        async getLanguagesAsync(): Promise<void> {
            this.languages = await Controllers.GenericController.getAsync<Language[]>("settings/languages?in_own_language=true");
        },

        async saveUserLanguage() {
            const user = {
                language: this.languageCode
            };
            const result = await storeHelper.userStore.saveUserAsync(this.$user.user_id, user as UserPatch);
            if (result) {
                await this.getLanguagesAsync();
                this.languageCode = this.languages.filter(lang => lang.default == true)[0].code;
                if (storeHelper.subscriptionsStore.subscriptions) {
                    await storeHelper.subscriptionsStore.loadMySubscriptionsAsync();
                }
                storeHelper.siteStore.setSnackBarMessage(
                    this.$t("settings.messages.setLanguageSuccessfully", {
                        language: this.languages.filter(lang => lang.code == this.languageCode)[0].name
                    }).toString(),
                    false,
                    SnackBarTimeout.short
                );

                // update current session data about the language in webforms iprova via this "fire and forget"
                // No-Store is needed to fix IE bug 63050
                const headers = { "Cache-Control": "No-Store", Pragma: "no-cache" };
                Controllers.GenericController.getAsync("../Management/ApplicationManagement/User/UpdateUserLanguage.ashx", null, headers);
            } else {
                storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString(), true);
            }
        },
        async saveStartPortal() {
            if (this.startPortal) {
                const user = {
                    start_portal_id: this.startPortal.portal_id
                };
                const result = await storeHelper.userStore.saveUserAsync(this.$user.user_id, user as UserPatch);
                if (result) {
                    storeHelper.siteStore.setSnackBarMessage(
                        this.$t("settings.messages.setStartPortalSuccessfully", {
                            portalName: this.startPortal.name
                        }).toString(),
                        false,
                        SnackBarTimeout.short
                    );
                } else {
                    storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString(), true);
                }
            }
        },
        async saveUserDateFormat() {
            const user = {
                date_format: this.dateFormat
            };
            const result = await storeHelper.userStore.saveUserAsync(this.$user.user_id, user as UserPatch);
            if (result) {
                storeHelper.siteStore.setSnackBarMessage(
                    this.$t("settings.messages.setDateFormatSuccessfully", {
                        dateFormat: this.$t("general.dateFormats." + this.dateFormat.split(".").join("="))
                    }).toString(),
                    false,
                    SnackBarTimeout.short
                );
            } else {
                storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString(), true);
            }
        },
        async loadTimeZones() {
            this.timeZones = await storeHelper.timeZonesStore.getTimeZonesAsync();
            if (this.$user?.time_zone_id !== null) this.timeZone = this.timeZones.find(x => x.id == this.$user.time_zone_id);
        },
        async saveUserTimeZone() {
            const user: Partial<UserPatch> = {
                time_zone_id: this.timeZone.id
            };

            const result = await storeHelper.userStore.saveUserAsync(this.$user.user_id, user);
            if (result) {
                storeHelper.siteStore.setSnackBarMessage(
                    this.$t("settings.messages.setTimeZoneSuccessfully", { timeZoneDisplayName: this.timeZone.display_name }).toString(),
                    false,
                    2
                );
            } else {
                storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString(), true);
            }
        }
    }
});
